export const link = 'https://bnnvara.nl/pagina/algemene-voorwaarden';

export const allAmountOptions = new Map();

const ONCE = 'oneTime';
export const MONTHLY = 'monthly';
const YEARLY = 'annual';
export const DEFAULT_PERIOD = MONTHLY;

allAmountOptions.set(ONCE, [
  { value: '5', label: '€5', isDefault: false },
  { value: '10', label: '€10', isDefault: true },
  { value: '20', label: '€20', isDefault: false },
  { value: 'anders', label: 'ANDERS', isDefault: false },
]);

allAmountOptions.set(MONTHLY, [
  { value: '2', label: '€2', isDefault: false },
  { value: '5', label: '€5', isDefault: true },
  { value: '10', label: '€10', isDefault: false },
  { value: 'anders', label: 'ANDERS', isDefault: false },
]);

allAmountOptions.set(YEARLY, [
  { value: '15', label: '€15', isDefault: false },
  { value: '20', label: '€20', isDefault: true },
  { value: '50', label: '€50', isDefault: false },
  { value: 'anders', label: 'ANDERS', isDefault: false },
]);

export const paymentTermOptions = [
  { text: 'Ik geef maandelijks', value: MONTHLY },
  { text: 'Ik geef jaarlijks', value: YEARLY },
  { text: 'Ik geef eenmalig', value: ONCE },
];
